import * as React from "react"
const SvgCalendarEmpty = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M5 22.286q-.824 0-1.413-.588A1.93 1.93 0 0 1 3 20.286v-14q0-.825.587-1.413A1.93 1.93 0 0 1 5 4.286h1v-1a.97.97 0 0 1 .287-.713A.97.97 0 0 1 7 2.286a.97.97 0 0 1 .713.287Q8 2.861 8 3.286v1h8v-1q0-.425.288-.713A.97.97 0 0 1 17 2.286q.424 0 .712.287.288.288.288.713v1h1q.824 0 1.413.587.587.588.587 1.413v14q0 .825-.587 1.412a1.93 1.93 0 0 1-1.413.588zm0-2h14v-10H5zm0-12h14v-2H5z" />
  </svg>
)
export default SvgCalendarEmpty
